import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'

import { ArrowCircleRightIcon } from '@10xLabs/react-web/components/Icons/ArrowCircleRight'
import { Dropdown } from 'components/v2/Dropdown'
import { FormattedPrice } from '@10xLabs/react-web/components/FormattedPrice'
import { StyledLink } from 'components/v2/Link'
import { LabelWrapper, Label, ReturnTripsWrapper, ReturnIcon } from '../Service'
import { isTicketCancelled } from 'resolvers/bookings'
import { IBookingTicketsServiceFees, ITicketsServiceFees } from './types'
import { ReactElement } from 'react'
import { sanitizePrice } from 'utils/math'
import { passengerTypeMessages } from '../PassengerType/messages'
import { safeFormatMessage } from 'utils/intl'

const ReturnTripsCell = styled(ReturnTripsWrapper)<{ showDepartureTrips: boolean }>``

const Table = styled.table<TSFixMe>`
  width: 100%;
  border-collapse: collapse;
`

const Tr = styled.tr<TSFixMe>`
  background-color: #ffffff;

  :hover {
    background-color: #f2f2f2;
  }
`

const Td = styled.td<TSFixMe>`
  padding: 10px;
`

const PassengerNameCell = styled(Td)<TSFixMe>`
  white-space: nowrap;
`

const ServiceFees = ({ tickets, currencyCode }: ITicketsServiceFees): ReactElement => {
  const intl = useIntl()

  return (
    <div>
      {tickets.length > 0 ? (
        <Dropdown toggle={<StyledLink>{tickets.length}</StyledLink>} noPadding fitContent>
          <Table>
            <tbody>
              {tickets.map((ticket, index): ReactElement => {
                const { seat } = ticket
                const passenger = ticket.passenger
                const { firstName, lastName } = passenger || {}
                const ticketServiceFee = ticket.serviceFee?.price ?? 0

                return (
                  <Tr key={index}>
                    <PassengerNameCell>
                      {!firstName && !lastName ? 'N/A' : `${firstName} ${lastName}`}
                    </PassengerNameCell>
                    <Td>{seat?.label}</Td>
                    <Td>
                      {safeFormatMessage({
                        intl,
                        messages: passengerTypeMessages,
                        key: ticket.passenger?.type?.name || ''
                      })}
                    </Td>
                    <Td>
                      <FormattedPrice value={sanitizePrice(ticketServiceFee)} currency={currencyCode} />
                    </Td>
                  </Tr>
                )
              })}
            </tbody>
          </Table>
        </Dropdown>
      ) : (
        0
      )}
    </div>
  )
}

export const BookingTicketsServiceFee = ({
  tickets,
  departureTrips,
  returnTrips,
  showDepartureTrips,
  showReturnTrips,
  currencyCode
}: IBookingTicketsServiceFees): ReactElement => {
  return (
    <div>
      {showDepartureTrips && (
        <>
          {showReturnTrips && (
            <LabelWrapper>
              <ArrowCircleRightIcon />
              <Label>
                <FormattedMessage id="dictionary.departure" defaultMessage="Departure" />
              </Label>
            </LabelWrapper>
          )}

          {departureTrips.map((trip, index): ReactElement => {
            const tripTickets = tickets.filter(
              (ticket): TSFixMe => ticket.trip?.id === trip.id && !isTicketCancelled(ticket) && ticket.serviceFee
            )

            return <ServiceFees key={index} tickets={tripTickets} currencyCode={currencyCode} />
          })}
        </>
      )}

      {showReturnTrips && (
        <ReturnTripsCell showDepartureTrips>
          {showDepartureTrips && (
            <LabelWrapper>
              <ReturnIcon />

              <Label>
                <FormattedMessage id="dictionary.return" defaultMessage="Return" />
              </Label>
            </LabelWrapper>
          )}

          {returnTrips.map((trip, index): ReactElement => {
            const tripTickets = tickets.filter(
              (ticket): TSFixMe => ticket.trip?.id === trip.id && !isTicketCancelled(ticket) && ticket.serviceFee
            )

            return <ServiceFees key={index} tickets={tripTickets} currencyCode={currencyCode} />
          })}
        </ReturnTripsCell>
      )}
    </div>
  )
}
